module.exports = __webpack_public_path__ + "public/img/user-icon.f1e47125.png";